const { clientType: ClientType } = require('./client');

const EmailType = {
  DISPATCH_NOTIFICATION:
  {
    name: 'DISPATCH_NOTIFICATION',
    bulk: false,
    clientType: ClientType.TRANSPORTER,
    multiRole: true,
  },
  CONSIGNEE_DELIVERY_NOTIFICATION:
    {
      name: 'CONSIGNEE_DELIVERY_NOTIFICATION',
      bulk: false,
      clientType: ClientType.CONSIGNEE,
      multiRole: true,
    },
  CONSIGNEE_LOGIN: {
    name: 'CONSIGNEE_LOGIN', bulk: false, clientType: ClientType.CONSIGNEE, multiRole: true,
  },
  CONSIGNEE_USER_LOGIN: {
    name: 'CONSIGNEE_USER_LOGIN', bulk: false, clientType: ClientType.CONSIGNEE_USER, multiRole: true,
  },
  CONSIGNEE_PASSWORD_RESET:
    {
      name: 'CONSIGNEE_PASSWORD_RESET', bulk: false, clientType: ClientType.CONSIGNEE, multiRole: true,
    },
  APPROVER_REJECT_INVOICE:
    {
      name: 'APPROVER_REJECTE_INVOICE', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
    },
  BDR_HISTORY_EXPORT:
    {
      name: 'BDR_HISTORY_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
    },
  BUCC_EXPORT: {
    name: 'BUCC_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CONSIGNEE_EXPORT: {
    name: 'CONSIGNEE_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CONSIGNEE_REJECTIONS: {
    name: 'CONSIGNEE_REJECTIONS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CONTRACT_EXPIRY: {
    name: 'CONTRACT_EXPIRY', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  PURCHASE_ORDER_EXPIRY: {
    name: 'PURCHASE_ORDER_EXPIRY', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  CONTRACT_EXPORT: {
    name: 'CONTRACT_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CONTRACT_REJECTIONS: {
    name: 'CONTRACT_REJECTIONS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CONTRACT_TSD_MATRIX_EXPORT:
  {
    name: 'CONTRACT_TSD_MATRIX_EXPORT',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  COURIER_INTEGRATION_API_REJECTIONS:
  {
    name: 'COURIER_INTEGRATION_API_REJECTIONS',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  DELAY_STATUS_REPORT: {
    name: 'DELAY_STATUS_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  DELIVERY_PICKLIST_REJECTIONS:
  {
    name: 'DELIVERY_PICKLIST_REJECTIONS',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  DETENTION_EXPORT: {
    name: 'DETENTION_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  DETENTION_REJECTIONS: {
    name: 'DETENTION_REJECTIONS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  EMAIL_COURIER_SERVICE_ERROR:
  {
    name: 'EMAIL_COURIER_SERVICE_ERROR',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: false,
  },
  EPOD_REJECTIONS: {
    name: 'EPOD_REJECTIONS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  EXTRA_DROP_OFF_CHARGE_EXPORT:
  {
    name: 'EXTRA_DROP_OFF_CHARGE_EXPORT',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  INDENT_INBOUND_STATUS_REPORT:
  {
    name: 'INDENT_INBOUND_STATUS_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INDENT_STATUS_REPORT: {
    name: 'INDENT_STATUS_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INVOICE_EXPORT_PAY_V2: {
    name: 'INVOICE_EXPORT_PAY_V2', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INVOICE_ANNEXURE_PDF: {
    name: 'INVOICE_ANNEXURE_PDF', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INVOICE_EXPORT_WALLET_V2: {
    name: 'INVOICE_EXPORT_WALLET_V2', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INVOICE_STATUS_UPDATE: {
    name: 'INVOICE_STATUS_UPDATE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INVOICE_REJECTIONS:
  {
    name: 'INVOICE_REJECTIONS',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  REJECTIONS_EMAIL_NOTIFICATION: {
    name: 'REJECTIONS_EMAIL_NOTIFICATION', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INVOICES_EXPORT: {
    name: 'INVOICES_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  LOCATION_EXPORT: {
    name: 'LOCATION_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  VEHICLE_EXPORT: {
    name: 'VEHICLE_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  BASE_DIESEL_RATE_EXPORT: {
    name: 'BASE_DIESEL_RATE_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  MATERIAL_EXPORT: {
    name: 'MATERIAL_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  MATERIALS_REJECTIONS: {
    name: 'MATERIALS_REJECTIONS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  OPEN_MARKET_PLACEMENTS_REPORT:
  {
    name: 'OPEN_MARKET_PLACEMENTS_REPORT',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  OPTIMA_VS_DISPATCHED_MATERIALS:
  {
    name: 'OPTIMA_VS_DISPATCHED_MATERIALS',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  ORDER_MATERIAL_REJECTIONS:
  {
    name: 'ORDER_MATERIAL_REJECTIONS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  OS_N_D_REPORT: {
    name: 'OS_N_D_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  PAYMENT_COMPLAINCE: {
    name: 'PAYMENT_COMPLAINCE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  PAYMENT_REJECTION: {
    name: 'PAYMENT_REJECTION', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  POD_BULK_UPLOAD_ERROR:
  {
    name: 'POD_BULK_UPLOAD_ERROR', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  PURCHASE_ORDER_EXPORT: {
    name: 'PURCHASE_ORDER_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  DRIVER_EXPORT: {
    name: 'DRIVER_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ACROSS_INDENT_MATERIAL_BULK_UPLOAD_ERROR:
  {
    name: 'ACROSS_INDENT_MATERIAL_BULK_UPLOAD_ERROR', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ACROSS_INDENT_MATERIAL_BULK_UPLOAD_SUCCESS:
  {
    name: 'ACROSS_INDENT_MATERIAL_BULK_UPLOAD_SUCCESS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },

  EMAIL_MODIFIED_PICKLIST_NOTIFICATION:
  {
    name: 'EMAIL_MODIFIED_PICKLIST_NOTIFICATION',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },

  POD_EXCEPTION_EXPORT:
  {
    name: 'POD_EXCEPTION_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TOTAL_DISTANNCE_REPORT:
  {
    name: 'TOTAL_DISTANNCE_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TRACK_AND_TRACE_REPORT:
  {
    name: 'TRACK_AND_TRACE_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TRANSPORTER_EXPORT: {
    name: 'TRANSPORTER_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TRANSPORTER_PERFORMANCE_REPORT:
  {
    name: 'TRANSPORTER_PERFORMANCE_REPORT',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  TRANSPORTER_REJECTIONS:
  {
    name: 'TRANSPORTER_REJECTIONS', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  GIT_REPORT:
  { name: 'GIT_REPORT', bulk: false, clientType: ClientType.SHIPPER },
  USERS_EXPORT: {
    name: 'USERS_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CHA_EXPORT: {
    name: 'CHA_EXPORT', bulk: false, clientType: ClientType.CLEARING_HOUSE_AGENT, multiRole: true,
  },
  FREIGHT_FORWARDER_EXPORT: {
    name: 'FREIGHT_FORWARDER_EXPORT', bulk: false, clientType: ClientType.FREIGHT_FORWARDER, multiRole: true,
  },
  PORTS_EXPORT: {
    name: 'PORTS_EXPORT', bulk: false, multiRole: true,
  },
  DEPOTS_EXPORT: { name: 'DEPOTS_EXPORT', bulk: false, multiRole: true },
  VEHICLE_UITLIZATION_NOTIFICATION:
  {
    name: 'VEHICLE_UITLIZATION_NOTIFICATION',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  VEHICLE_UTILIZATION_CHECK_REPORT:
  {
    name: 'VEHICLE_UTILIZATION_CHECK_REPORT',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  VEHICLETYPES_BIFURCATION_REPORT:
  {
    name: 'VEHICLETYPES_BIFURCATION_REPORT',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  WALLET_EXPORT: {
    name: 'WALLET_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  FREIGHT_PROVISION_REPORT:
  {
    name: 'FREIGHT_PROVISION_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  BULK_ORDER_NOTIFICATION:
  {
    name: 'BULK_ORDER_NOTIFICATION', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  ORDER_NOTIFICATION: {
    name: 'ORDER_NOTIFICATION', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: false,
  },
  GRN_ON_REPORT_RELEASE_TRANSPORTER: {
    name: 'GRN_NOTIFICATION_TRANSPORTER', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  GRN_ON_REPORT_RELEASE_CONSIGNEE: {
    name: 'GRN_NOTIFICATION_CONSIGNEE', bulk: false, clientType: ClientType.CONSIGNEE, multiRole: true,
  },
  REQUIREMENT_DATE_CHANGE:
  {
    name: 'REQUIREMENT_DATE_CHANGE', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  TRANSPORTER_RFQ_CREATE:
  {
    name: 'TRANSPORTER__RFQ_CREATE', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  TRANSPORTER_RFQ_EXPIRY:
  {
    name: 'TRANSPORTER__RFQ_EXPIRY', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  TRANSPORTER_ACCEPTANCE_REMINDER:
  {
    name: 'TRANSPORTER_ACCEPTANCE_REMINDER',
    bulk: false,
    clientType: ClientType.TRANSPORTER,
    multiRole: true,
  },
  TRANSPORTER_ACCEPTANCE_BREACH:
  {
    name: 'TRANSPORTER_ACCEPTANCE_BREACH',
    bulk: false,
    clientType: ClientType.TRANSPORTER,
    multiRole: true,
  },
  TRANSPORTER_ARRIVAL_REMINDER:
  {
    name: 'TRANSPORTER_ARRIVAL_REMINDER',
    bulk: false,
    clientType: ClientType.TRANSPORTER,
    multiRole: true,
  },
  TRANSPORTER_ASSIGNMENT_REMINDER:
  {
    name: 'TRANSPORTER_ASSIGNMENT_REMINDER',
    bulk: false,
    clientType: ClientType.TRANSPORTER,
    multiRole: true,
  },
  TRANSPORTER_FORGOT_PASSWORD:
  {
    name: 'TRANSPORTER_FORGOT_PASSWORD',
    bulk: false,
    clientType: ClientType.TRANSPORTER,
    multiRole: true,
  },
  TRANSPORTER_QUOTE_ACCEPTED:
  {
    name: 'TRANSPORTER_QUOTE_ACCEPTED',
    bulk: false,
    clientType: ClientType.TRANSPORTER,
    multiRole: true,
  },
  TRANSPORTER_RFQ_REJECT:
  {
    name: 'TRANSPORTER_RFQ_REJECT', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  TRANSPORTER_RFQ_REPLACE:
  {
    name: 'TRANSPORTER_RFQ_REPLACE', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  TRANSPORTER_USER_WELCOME:
  {
    name: 'TRANSPORTER_USER_WELCOME', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  TRANSPORTER_WELCOME: {
    name: 'TRANSPORTER_WELCOME', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: false,
  },
  TRUCK_NOT_RELEASED_CONSIGNEE:
  {
    name: 'TRUCK_NOT_RELEASED_CONSIGNEE',
    bulk: true,
    clientType: ClientType.CONSIGNEE,
    multiRole: true,
  },
  INDENT_DISPATCH_UPDATE_FOR_CONSIGNEE:
  {
    name: 'INDENT_DISPATCH_UPDATE_FOR_CONSIGNEE',
    bulk: true,
    clientType: ClientType.CONSIGNEE,
    multiRole: true,
  },
  INDENT_TRACKING_UPDATE_FOR_CONSIGNEE:
  {
    name: 'INDENT_TRACKING_UPDATE_FOR_CONSIGNEE',
    bulk: true,
    clientType: ClientType.CONSIGNEE,
    multiRole: true,
  },
  INDENT_BULK_TRANSPORTERS_NOTIFICATION:
  {
    name: 'INDENT_BULK_TRANSPORTERS_NOTIFICATION',
    bulk: true,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  SLA_ACCEPTANCE_BREACH:
    {
      name: 'TRANSPORTER_ACCEPTANCE_BREACH',
      bulk: true,
      clientType: ClientType.SHIPPER,
      multiRole: true,
    },
  TRANSIT_DELAY: {
    name: 'TRANSIT_DELAY', bulk: true, clientType: ClientType.CONSIGNEE, multiRole: true,
  },
  INDENT_PENDING_GRN: {
    name: 'INDENT_PENDING_GRN', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INDENT_REJECT_BY_USER: {
    name: 'INDENT_REJECT_BY_USER', bulk: true, clientType: ClientType.SHIPPER, multiRole: false,
  },
  INDENT_VEHICLE_TYPE_CHANGE_BY_TRANSPORTER:
  {
    name: 'INDENT_VEHICLE_TYPE_CHANGE_BY_TRANSPORTER',
    bulk: true,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  NEW_INDENT_CREATED: {
    name: 'NEW_INDENT_CREATED', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  SLA_SCHEDULER_REMINDER:
  {
    name: 'SLA_SCHEDULER_REMINDER', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  SLA_EXPORT: {
    name: 'SLA_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  LOADING_EXPORT: {
    name: 'LOADING_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TRANSIT_EXPORT: {
    name: 'TRANSIT_EXPORT', bulk: false, clientType: ClientType.SHIPPER , multiRole: true, 
  },
  TRUCK_CONGESTION_NOTIFICATION:
  {
    name: 'TRUCK_CONGESTION_NOTIFICATION',
    bulk: true,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  TRUCK_NOT_RELEASED_DEPOT:
  {
    name: 'TRUCK_NOT_RELEASED_DEPOT', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TRUCK_REJECTED: {
    name: 'TRUCK_REJECTED', bulk: true, clientType: [ClientType.SHIPPER, ClientType.TRANSPORTER], multiRole: true,
  },
  CHECKER_RETURNED_INVOICE:
  {
    name: 'CHECKER_RETURNED_INVOICE', bulk: true, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  E_INVOICE_VALIDATION: { 
    name: 'E_INVOICE_VALIDATION', bulk: true, clientType: [ClientType.SHIPPER, ClientType.TRANSPORTER], multiRole: true,
  },
  MIRO_EXPORT: {
    name: 'MIRO_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  PAYMENT_UPLOAD_REJECTION:
  {
    name: 'PAYMENT_UPLOAD_REJECTION', bulk: false, clientType: -1, multiRole: true,
  }, // Not in use
  POC_COMPLETION: {
    name: 'POC_COMPLETION', bulk: false, clientType: -1, multiRole: true,
  }, // Not in use
  OPTIMA_DELIVERY_REJECTIONS: {
    name: 'OPTIMA_DELIVERY_REJECTIONS', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  OPTIMA_REJECTIONS_REPORT: {
    name: 'OPTIMA_REJECTIONS_REPORT', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  PURCHASE_ORDER: {
    name: 'PURCHASE_ORDER', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  SHIPPER_FORGOT_PASSWORD: {
    name: 'SHIPPER_FORGOT_PASSWORD',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  TRIP_STATUS_REPORT: {
    name: 'TRIP_STATUS_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  PO_THRESHOLD_LIMIT: {
    name: 'PO_THRESHOLD_LIMIT', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  WORKFLOW_NOTIFICATION_SHIPPER: {
    name: 'WORKFLOW_NOTIFICATION_SHIPPER', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  WORKFLOW_NOTIFICATION_FREIGHT_FORWARDER: {
    name: 'WORKFLOW_NOTIFICATION_FREIGHT_FORWARDER', bulk: true, clientType: ClientType.FREIGHT_FORWARDER, multiRole: true,
  },
  WORKFLOW_NOTIFICATION_CHA: {
    name: 'WORKFLOW_NOTIFICATION_CHA', bulk: true, clientType: ClientType.CLEARING_HOUSE_AGENT, multiRole: true,
  },
  EXIM_INDENT_CREATE: {
    name: 'EXIM_INDENT_CREATE', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  EXIM_DELIVERED_TO_CONSIGNEE: {
    name: 'EXIM_DELIVERED_TO_CONSIGNEE', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  EXIM_INDENT_UPDATE: {
    name: 'EXIM_INDENT_UPDATE', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  FREIGHT_FORWARDER_CONTAINER_BOOKED: {
    name: 'FREIGHT_FORWARDER_CONTAINER_BOOKED', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  FREIGHT_FORWARDER_REJECT: {
    name: 'FREIGHT_FORWARDER_REJECT', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  EXIM_INDENT_RE_INDENT: {
    name: 'EXIM_INDENT_RE_INDENT', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  ERP_BULK_INDENT: {
    name: 'ERP_BULK_INDENT', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  WALLET_CREATE: {
    name: 'WALLET_CREATE', bulk: true, clientType: [ClientType.SHIPPER, ClientType.TRANSPORTER], multiRole: true,
  },
  WALLET_DISPUTE: {
    name: 'WALLET_DISPUTE', bulk: true, clientType: [ClientType.SHIPPER, ClientType.TRANSPORTER], multiRole: true,
  },
  DIESEL_PEG_CHANGE_NOTIFICATION: {
    name: 'DIESEL_PEG_CHANGE_NOTIFICATION', bulk: false, clientType: ClientType.SHIPPER, multiRole: false,
  },
  VEHICLE_UTILISATION_CHECK_NOTIFICATION: {
    name: 'VEHICLE_UTILISATION_CHECK_NOTIFICATION',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  DIRECT_DISPATCH_CREATION: {
    name: 'DIRECT_DISPATCH_CREATION', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ACCOUNT_INACTIVE:
  {
    name: 'ACCOUNT_INACTIVE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  MATERIAL_INVOICE_GRN: {
    name: 'MATERIAL_INVOICE_GRN',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  FREIGHT_PROVISION_POSTING:
  {
    name: 'FREIGHT_PROVISION_POSTING', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INVOICE_POSTING:
  {
    name: 'INVOICE_POSTING', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  VEHICLE_BULK:
    {
      name: 'VEHICLE_BULK', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
    },
  TRANSPORTATION_DB_EXPORT: {
    name: 'TRANSPORTATION_DB_EXPORT', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  MATERIAL_DELETE_VIA_UPLOAD:
    {
      name: 'MATERIAL_DELETE_VIA_UPLOAD', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
    },
  LOCATION_MILESTONE_UPLOAD:
  {
    name: 'LOCATION_MILESTONE_UPLOAD', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  MATERIAL_INVOICE_WITH_PACKAGE: {
    name: 'MATERIAL_INVOICE_WITH_PACKAGE',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  RFQ_DEBIT:
  {
    name: 'RFQ_DEBIT', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  LR_NOTIFICATION:
  {
    name: 'RFQ_DEBIT', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  RFQ_NOTIFICATION:
  {
    name: 'RFQ_NOTIFICATION', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  HACH_INDENTED_REPORT:
  {
    name: 'HACH_INDENTED_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  DRIVER_BEHAVIOUR_REPORT:
  {
    name: 'DRIVER_BEHAVIOUR_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CONSIGNMENT_UPLOAD:
  {
    name: 'CONSIGNMENT_UPLOAD', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  PRE_PLAN_MATERIAL:
  {
    name: 'PRE_PLAN_MATERIAL', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ADVANCE_SHIPMENT_NOTICE:
  {
    name: 'ADVANCE_SHIPMENT_NOTICE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  INDENT_DISTANCE_UPLOAD: {
    name: 'INDENT_DISTANCE_UPLOAD',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  GRN_INTERFACE:
  {
    name: 'GRN_INTERFACE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  PACKAGE_MASTER_EXPORT: {
    name: 'PACKAGE_MASTER_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ERP_MATERIAL_DELETE:
  {
    name: 'ERP_MATERIAL_DELETE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ERP_TRUCK_IN:
  {
    name: 'ERP_TRUCK_IN', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  REACH_AND_RELEASE:
  {
    name: 'REACH_AND_RELEASE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  EWAY_BILL_ABOUT_TO_BE_EXPIRED:
  {
    name: 'EWAY_BILL_ABOUT_TO_BE_EXPIRED', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ACTIVITY_TIME_EXPORT: {
    name: 'ACTIVITY_TIME_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ERP_TRUCK_OUT:
  {
    name: 'ERP_TRUCK_OUT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TRACK_AND_TRACE_GPS_REPORT:
  {
    name: 'TRACK_AND_TRACE_GPS_REPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  GENERATE_OTP:
  {
    name: 'GENERATE_OTP', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  APPROVE_OTP:
  {
    name: 'APPROVE_OTP', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  MATERIAL_INVOICE_EPOD:
  {
    name: 'MATERIAL_INVOICE_EPOD', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  ERP_VEHICLE_UPDATE:{
    name: 'ERP_VEHICLE_UPDATE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TRANSSHIPMENT_EXPORT:{
    name: 'TRANSSHIPMENT_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  OPTIMA_RUN_COMPLETED_NOTIFIER:{
    name: 'OPTIMA_RUN_COMPLETED_NOTIFIER', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  OPEN_INDENT_APPROVAL_REJECT_NOTIFICATION:
  {
    name: 'OPEN_INDENT_APPROVAL_REJECT_NOTIFICATION', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  EPOD_INDENT_APPROVAL_REJECT_NOTIFICATION:
  {
    name: 'EPOD_INDENT_APPROVAL_REJECT_NOTIFICATION', bulk: true, clientType: ClientType.SHIPPER, multiRole: true,
  },
  REDIRECTION_EXPORT:{
    name: 'REDIRECTION_EXPORT', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  RETURN_DELIVERY_DISCARD_NOTIFICATION: {
    name: 'RETURN_DELIVERY_DISCARD_NOTIFICATION', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  RETURN_REQUEST_REJECT_NOTIFIER: {
    name: 'RETURN_REQUEST_REJECT_NOTIFIER', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CREATE_RETURN_REQUEST_SHIPPER_NOTIFIER: {
    name: 'CREATE_RETURN_REQUEST_SHIPPER_NOTIFIER', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CREATE_RETURN_REQUEST_TRANSPORTER_NOTIFIER: {
    name: 'CREATE_RETURN_REQUEST_TRANSPORTER_NOTIFIER', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  REQUEST_TO_INDENT_CREATION_NOTIFIER: {
    name: 'REQUEST_TO_INDENT_CREATION_NOTIFIER', bulk: true, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  CREATE_RETURN_DELIVERY_SHIPPER_NOTIFIER: {
    name: 'CREATE_RETURN_DELIVERY_SHIPPER_NOTIFIER', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  CREATE_RETURN_DELIVERY_TRANSPORTER_NOTIFIER: {
    name: 'CREATE_RETURN_DELIVERY_TRANSPORTER_NOTIFIER', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  RETURN_APPROVAL_PENDING_NOTIFIER: {
    name: 'RETURN_APPROVAL_PENDING_NOTIFIER', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  DELIVERY_PICKLIST_WITH_CONSIGNEE:{
    name: 'DELIVERY_PICKLIST_WITH_CONSIGNEE', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  TWO_FACTOR_AUTH_OTP: {
    name: 'TWO_FACTOR_AUTH_OTP',
  },
  SHIPPER_USER_WELCOME: {
    name: 'SHIPPER_USER_WELCOME',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  HYPERTRACK_REPORT: {
    name: 'HYPERTRACK_REPORT',
    bulk: false,
    clientType: ClientType.SHIPPER,
    multiRole: true,
  },
  RETURN_WITH_EPOD_REJECTIONS: {
    name: 'RETURN_WITH_EPOD_REJECTIONS',
    bulk: true,
    clientType: ClientType.TRANSPORTER,
    multiRole: false,
  },
  DIGITAL_SIGNATURE_PENDING_SHIPPER_NOTIFIER: {
    name: 'DIGITAL_SIGNATURE_PENDING_SHIPPER_NOTIFIER', bulk: false, clientType: ClientType.SHIPPER, multiRole: true,
  },
  DIGITAL_SIGNATURE_PENDING_TRANSPORTER_NOTIFIER: {
    name: 'CREATE_RETURN_DELIVERY_TRANSPORTER_NOTIFIER', bulk: false, clientType: ClientType.TRANSPORTER, multiRole: true,
  },
  LR_ATTCHMENT_REJECTIONS_NOTIFICATIONS: {
    name: "LR_ATTCHMENT_REJECTIONS_NOTIFICATIONS", bulk: false, clientType: ClientType.TRANSPORTER, multiRole: false,
  }
};

module.exports = EmailType;
